export enum CookieIdentifiers {
  USER_ID = 'userId',
  TOKEN_ID = 'token'
}
